export default __webpack_public_path__ + "static/in-w2-amazon-main-diagram-en4-9598c2b26adb7ceba98d190a44c0fffb.webp";